export const filter = {
  id : '',  
  skill: '', 
  created_at: '',
  updated_at: ''  
};
